import { render, staticRenderFns } from "./EditorDiv.vue?vue&type=template&id=7dc81497&scoped=true&"
import script from "./EditorDiv.vue?vue&type=script&lang=js&"
export * from "./EditorDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc81497",
  null
  
)

export default component.exports